export default function OptimizerUseCases() {
  const useCases = [
    {
      title: '出版印刷',
      description: '优化大型出版文件，确保高质量打印输出的同时减少文件传输时间。',
      image: 'https://public.readdy.ai/ai/img_res/b0ec826bb72b53c8ee66de31e7045f64.jpg'
    },
    {
      title: '企业归档',
      description: '符合PDF/A标准的长期文档归档，满足法规和合规性要求。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20archive%20system%20with%20organized%20PDF%20documents%20in%20secure%20storage%20facility%2C%20clean%20corporate%20environment%20with%20document%20management%20infrastructure%2C%20professional%20lighting%20with%20teal%20and%20cyan%20accents%2C%20realistic%20photography%20showing%20enterprise%20document%20archiving&width=800&height=500&seq=optimizer-archive-2&orientation=landscape'
    },
    {
      title: '移动应用',
      description: '为移动设备优化PDF文档，提供快速加载和流畅的阅读体验。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20and%20tablet%20displaying%20optimized%20PDF%20documents%20with%20fast%20loading%2C%20clean%20mobile%20interface%20with%20professional%20document%20viewing%2C%20bright%20environment%20with%20teal%20and%20cyan%20color%20scheme%2C%20realistic%20photography%20showing%20mobile%20PDF%20optimization&width=800&height=500&seq=optimizer-mobile-3&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            应用场景
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            在各行各业中发挥关键作用
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {useCases.map((useCase, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="relative overflow-hidden h-64">
                <img 
                  src={useCase.image}
                  alt={useCase.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {useCase.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {useCase.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
